import React from 'react';
import { Masonry } from '@forgeglobal/design-framework';
import useMasonryDynamicColumns from '@tcs/common/hooks/useMasonryDynamicColumns';
import TermsCard from '@tcs/client-portal-common/components/templates/DetailCards/TermsCard';

interface ProfileSettingsProps {
  accountNumber: string;
}

const ProfileSettings = ({ accountNumber }: ProfileSettingsProps) => {
  const dynamicColumns = useMasonryDynamicColumns('lg', 2);

  if (!accountNumber) {
    return null;
  }

  return (
    <Masonry numCols={dynamicColumns}>
      <TermsCard accountNumber={accountNumber} />
    </Masonry>
  );
};

export default ProfileSettings;
